/**
 * Base 100 (planilla / BD): horas decimales = minutos ÷ 60 (8.75 = 8 h 45 min).
 * Base 60 (tareos UI): reloj HH:MM (8.75 → 8:45).
 */

export function redondearHorasBase100(horasDecimales) {
  const n = parseFloat(horasDecimales);
  if (!Number.isFinite(n)) return 0;
  return Math.round(n * 100) / 100;
}

/** Decimal planilla → HH:MM para pantalla de tareos */
export function decimalBase100ABase60(horasDecimales) {
  const n = redondearHorasBase100(horasDecimales);
  if (n === 0) return '0:00';

  const esNegativo = n < 0;
  const abs = Math.abs(n);
  const horas = Math.floor(abs);
  let minutos = Math.round((abs - horas) * 60);
  if (minutos === 60) {
    return `${esNegativo ? '-' : ''}${horas + 1}:00`;
  }
  const minutosStr = String(minutos).padStart(2, '0');
  return `${esNegativo ? '-' : ''}${horas}:${minutosStr}`;
}

/** HH:MM → decimal planilla (8:45 → 8.75) */
export function base60ADecimalBase100(horasMinutosStr) {
  if (horasMinutosStr == null || horasMinutosStr === '') return 0;

  const raw = String(horasMinutosStr).trim();
  if (!raw.includes(':')) {
    return redondearHorasBase100(parseFloat(raw) || 0);
  }

  const esNegativo = raw.startsWith('-');
  const strSinSigno = esNegativo ? raw.slice(1) : raw;
  const partes = strSinSigno.split(':');
  if (partes.length < 2) {
    return redondearHorasBase100(parseFloat(raw) || 0);
  }

  const horas = parseInt(partes[0], 10) || 0;
  const minutos = parseInt(partes[1], 10) || 0;
  const decimal = horas + minutos / 60;
  return redondearHorasBase100(esNegativo ? -decimal : decimal);
}

export function formatearHorasTareoBase60(horasDecimales) {
  return decimalBase100ABase60(horasDecimales);
}

export function formatearHorasPlanillaBase100(horasDecimales) {
  return redondearHorasBase100(horasDecimales).toFixed(2);
}

export function tituloHorasTareoYPlanilla(horasDecimales) {
  const dec = redondearHorasBase100(horasDecimales);
  return `${formatearHorasTareoBase60(dec)} · planilla ${formatearHorasPlanillaBase100(dec)} h`;
}

/** Decimal planilla → HH:MM para inputs de configuración de horas (tareo por horas). */
export function horasConfigDecimalABase60(horasDecimales) {
  return decimalBase100ABase60(horasDecimales);
}

/** HH:MM (o número legacy) → decimal planilla para guardar en backend. */
export function horasConfigBase60ADecimal(horasMinutosStr) {
  return base60ADecimalBase100(horasMinutosStr);
}

/** Normaliza texto HH:MM para validación en importación / blur. */
export function normalizarHorasConfigTexto(valor) {
  if (valor === null || valor === undefined || valor === '') return null;
  const s = String(valor).trim();
  if (/^\d{1,2}:\d{2}$/.test(s)) {
    const [h, m] = s.split(':').map(Number);
    return `${String(h).padStart(2, '0')}:${String(m).padStart(2, '0')}`;
  }
  if (/^\d{1,2}:\d{1,2}$/.test(s)) {
    const [h, m] = s.split(':');
    return `${String(parseInt(h, 10)).padStart(2, '0')}:${String(parseInt(m, 10)).padStart(2, '0')}`;
  }
  return null;
}

export default {
  redondearHorasBase100,
  decimalBase100ABase60,
  base60ADecimalBase100,
  formatearHorasTareoBase60,
  formatearHorasPlanillaBase100,
  tituloHorasTareoYPlanilla,
};
